import { Component } from 'react';
import {
    ImsItemSelectorProps,
    Option,
} from 'app/shared/components/ims_object_selector/ims_item_selector';

export enum selectorOptionTypes {
    ASSET_OPTIONS_PANEL = 'asset_option_panel',
    BOTTOM_PANEL_DATA = 'bottom_panel_data',
    TRIGGER_COUNT_TYPE_DATA = 'trigger_count_type_data',
    DASHBOARD_DATA_SOURCE = 'dashboard_data_source',
    DASHBOARD_AGGREGATION_TYPE = 'dashboard_aggregation_type',
    DASHBOARD_AXIS_VALUE = 'dashboard_axis_value',
    DASHBOARD_AGGREGATION_FILTER_OPERATOR = 'dashboard_aggregation_filter_operator',
    DASHBOARD_POST_AGGREGATION_FILTER_DISPLAY_UNIT = 'dashboard_post_aggregation_filter_display_unit',
    HEATMAP_DATA = 'heatmap_data',
    HEATMAP_FILTERED_DATA = 'heatmap_filtered_data',
    TRIGGER_FILTER_TYPE = 'trigger_filtered_type',
    TRIGGER_FIELD_DATA = 'trigger_field_data',
    TRIGGER_ACTION_DATA = 'trigger_action_data',
    STAT_TYPE_DATA = 'stat_type_data',
    RF_RES_OPTIONS = 'rf_res_options',
    RF_COVERAGE_LAYER_TYPE_OPTIONS = 'rf_coverage_layer_type_options',
    DASHBOARD_ITEM_LEGEND_PAGE_SIZE = 'dashboard_item_legend_page_size',
    STAT_COLUMN_DATA = 'stat_column_data',
    TAG_OPTION_TYPE = 'tag_option_type',
    VALUE_NAME_OPTIONS = 'value_name_options',
    DISPLAY_VALUE_OPTIONS = 'display_value_options',
}

interface ImsItemSelectorAdapterProps<V> extends Omit<ImsItemSelectorProps<V>, 'options'> {
    rawOptions?: Array<any>; // type any is applicable here
    optionType?: selectorOptionTypes;
    itemType?: string;
    extraClasses?: string;
    options?: Option[];
}

export class ImsItemSelectorAdapter<V> extends Component<ImsItemSelectorAdapterProps<V>, never> {
    render() {
        return <div />;
    }
}
